import type { DetectionFeedbackReviewStatus } from '../types/api';

/** 전역 토스트·인라인 Alert 공통 문구 (P2-3) */
export const TOAST_COPY = {
  success: {
    login: '로그인되었습니다. 운영 현황으로 이동합니다.',
    feedbackSaved: '탐지 결과 검토를 저장했습니다.',
    bulkReview: (count: number) => `후보 ${count}건을 확정 처리했습니다.`,
    csvExport: (count: number, total: number) =>
      `CSV ${count}건을 내려받았습니다 (전체 ${total}건).`,
    trainingExport: (exported: number, isolated: number) =>
      `학습 JSON: 내보냄 ${exported}건, 격리 ${isolated}건.`,
    trainingUpload: '학습 데이터를 업로드했습니다.',
    trainingStart: '모델 학습을 시작했습니다.',
    trainingStop: '학습을 중지했습니다.',
    trainingDelete: '학습 데이터를 삭제했습니다.',
    modelExport: '모델을 내려받았습니다.',
  },
  info: {
    csvEmpty: '내려받을 피드백이 없습니다.',
  },
  error: {
    auth: '로그인이 필요합니다. 다시 로그인해 주세요.',
    network: '서버에 연결할 수 없습니다. 인터넷 연결과 운영 서버 상태를 확인해 주세요.',
    generic: '요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.',
    serverBusy: '서버가 일시적으로 바쁩니다. 잠시 후 다시 시도해 주세요.',
    feedbackSubmit: '피드백을 저장하지 못했습니다. 입력한 내용은 화면에 유지됩니다.',
    feedbackReview: '검토 상태를 변경하지 못했습니다.',
    feedbackBulk: '일괄 확정을 처리하지 못했습니다.',
    feedbackCsv: 'CSV를 내려받지 못했습니다.',
    feedbackExport: '학습 JSON을 만들지 못했습니다.',
    trainingList: '학습 데이터 목록을 불러오지 못했습니다.',
    trainingUpload: '학습 데이터 업로드에 실패했습니다.',
    trainingStart: '학습을 시작하지 못했습니다.',
    trainingStop: '학습 중지에 실패했습니다.',
    trainingDelete: '학습 데이터 삭제에 실패했습니다.',
    modelExport: '모델을 내려받지 못했습니다.',
    login: '아이디 또는 비밀번호가 올바르지 않습니다. 체험 계정은 로그인 화면 안내를 참고하세요.',
    monitoringStatus: '모니터링 API에 연결할 수 없습니다. 운영 서버와 로그인 세션을 확인해 주세요.',
  },
  reviewStatus: {
    candidate: '후보',
    confirmed: '확정',
    rejected: '반려',
  } satisfies Record<DetectionFeedbackReviewStatus, string>,
};

export const INLINE_COPY = {
  analysis: {
    syncFailed: 'analysis_id로 결과를 불러오지 못했습니다. Console API와 id를 확인해 주세요.',
    syncFailedStatus: '동기화된 분석이 실패 상태입니다.',
    processingFailed: '분석 중 오류가 발생했습니다.',
    statusPollFailed: '분석 상태를 확인하지 못했습니다.',
    uploadCanceled: '업로드를 취소했습니다.',
    uploadFailed: '파일 업로드에 실패했습니다.',
    upload503: TOAST_COPY.error.serverBusy,
  },
  dvos: {
    ackFailed: '승인(ack) 요청에 실패했습니다.',
    listFailed: 'DVOS 이벤트를 불러오지 못했습니다.',
  },
};

export type ToastCopy = typeof TOAST_COPY;
export type InlineCopy = typeof INLINE_COPY;
